import { createApiClient } from '../services/ApiClient';
import * as types from './ActionTypes';
import { getForms, getSettings } from "./index";
import { PAGINATION } from '../const/forms';

const { page, pagesize } = PAGINATION

export function auth(formKind?: number){
    return (dispatch: any) =>{
        const api = createApiClient();
        dispatch({ type: types.LOADING_START, payload: 'auth' });
        api.me({
            success:(data) => {
                if(data.isAuth && data.isAccess) {
                    dispatch({type: types.AUTH_USER_SUCCESS, payload: data});
                    dispatch({ type: types.LOADING_FINISH, payload: 'auth' });
                    dispatch(getSettings());
                    dispatch(getForms({
                        page,
                        pagesize,
                        formKind
                    }));
                    dispatch(getCompanies());
                } else if (!data.isAuth && data.isAccess)
                    api.redirect(window.location.href);
                else if(data.isAuth && !data.isAccess)
                    api.singout(window.location.href);
                else
                    if(window.top !== window.self)
                        window.top.location.href = '/#/not-authorized';
                    else
                      window.location.href = '/#/not-authorized';
            }
        })
    }
}

export function getCompanies() {
    return (dispatch: any) => {
        const api = createApiClient();
        dispatch({ type: types.LOADING_START, payload: 'companies' });
        api.getCompanies({
            success: (response ) => {
                dispatch({ type: types.FETCH_COMPANIES, payload: response });
            },
            anyway: () => {
                dispatch({ type: types.LOADING_FINISH, payload: 'companies' });
            }
        })
    }
}

export function setSelectedCompany(data: any) {
    return (dispatch: any) => {
        dispatch({ type: types.SET_SELECTED_COMPANY, payload: data });
    }
}







//
// export function createForm(values: any) {
//     return (dispatch:any) => {
//         dispatch({ type: types.LOADING_START, payload: 'companies' });
//         api.createForm({
//             orn: values.selectedCompany.value.company_orn,
//         }, {
//             success: response => {
//                 dispatch({ type: types.LOADING_FINISH, payload: 'companies' });
//                 const { process_id, form_type } = response;
//                 history.push(`${URL_PREFIX}/forms/${form_type}/${process_id}`)
//                 dispatch(getForms(PAGINATION.page, PAGINATION.pagesize));
//             },
//             error: error => {
//                 console.log('ACTION: createForm API error', error);
//                 dispatch({ type: types.LOADING_FINISH, payload: 'companies' });
//             }
//         })
//     }
// }